import { DefaultsInterface } from 'lib/StructuredData/defaults';

type title = {
  [key: string]: string;
};

const breadcrumbTitle: title = {
  'news-and-analysis': 'News and Analysis',
  guides: 'Guides',
};

interface BreadcrumbInterface {
  '@type': string;
  itemListElement: Array<ItemListElement>;
}

interface ItemListElement {
  '@type': string;
  position: string;
  name?: string;
  item?: string;
}

type breadcrumbStructuredData = DefaultsInterface & BreadcrumbInterface;

const breadcrumbStructuredData = ({
  url,
  title,
  breadcrumbCategory,
}: {
  url?: string;
  title?: string;
  breadcrumbCategory: string;
}): breadcrumbStructuredData => {
  const itemListElement1 = {
    '@type': 'ListItem',
    position: '1',
    name: breadcrumbTitle[breadcrumbCategory],
    item: `https://www.autolist.com/${breadcrumbCategory}`,
  };

  const itemListElement2 = {
    '@type': 'ListItem',
    position: '2',
    name: title,
    item: url,
  };

  const hasParentPage = url && title;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [itemListElement1, ...(hasParentPage ? [itemListElement2] : [])],
  };
};

export default breadcrumbStructuredData;
